/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreditCardTokenDetail {
  businessUnitId?: number;
  businessUnitName?: string;
  cardId?: string;
  cardIdMasked?: string;
  customerId?: string;
  customerIdMasked?: string;
  dateCreated?: Date;
  gatewayId?: number;
  gatewayName?: string;
  hasToken?: boolean;
  issuerId?: string;
}
